import { reduxForm, formValueSelector } from 'redux-form';
import { fetchGroupDetail, fetchGroups, fetchPermissions, editGroupDetail, createGroupDetail } from '../../actions/settings_actions';
import { connect } from 'react-redux';

import GroupManagementDetail from '../../components/Settings/groupManagementDetail';

let groupManagementDetail = reduxForm({
    form: 'groupManagementDetail',
})(GroupManagementDetail);

function mapStateToProps(state) {
    return {
        currentGroup: state.settings.currentGroup,
        groupDetail: state.settings.groupDetail,
        isLoading: state.settings.groupDetailIsLoading,
        error: state.settings.groupDetailError,
        initialValues: state.settings.groupDetail,
        groups: state.settings.groups,
        groupsError: state.settings.groupsError,
        groupsIsLoading: state.settings.groupsIsLoading,
        permissions: state.settings.permissions,
        permissionsIsLoading: state.settings.permissionsIsLoading,
        permissionsError: state.settings.permissionsError,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { fetchGroupDetail, fetchGroups, fetchPermissions, editGroupDetail, createGroupDetail })(groupManagementDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/groupManagementDetail.jsx